export default "/_next/static/chunks/fonts/WhitneySSm-BlackItalic-Pro_Web-eeb9c4f34e680dffa06841fc135b3a6d.woff2";